import {Table, TBody, Td, Th, Thead, Tr} from '@/components';
import type {Metrics} from '@/screens/Processor/Metrics/types';

export interface SPPTableProps {
  metrics: Metrics;
}
export const ratesHeaderHue = 'bg-blue-50 p-8 shadow-sm sticky';
const SuccessPerProcessorTable = ({metrics}: SPPTableProps) => {
  return (
    <Table className="w-full">
      <Thead className={ratesHeaderHue}>
        <Tr enableHover={false}>
          <Th className="px-2">Processor</Th>
          <Th className="px-2">Success Rate (%)</Th>
        </Tr>
      </Thead>
      <TBody>
        {Object.keys(metrics.processorSuccessRates)
          .sort(
            (a, b) =>
              metrics.processorSuccessRates[a] -
              metrics.processorSuccessRates[b],
          )
          .map((processor, index) => (
            <SPPRow
              key={processor}
              index={index}
              metrics={metrics}
              processor={processor}
            />
          ))}
      </TBody>
    </Table>
  );
};

const SPPRow = ({
  metrics,
  processor,
  index,
}: {
  metrics: Metrics;
  processor: string;
  index: number;
}) => {
  const zebraRow = index % 2 === 0 ? '' : 'bg-gray-50 dark:bg-dark-zebraRow';

  return (
    <Tr className={zebraRow}>
      <Td className={`px-2 font-medium`}>{processor}</Td>
      <Td className={`px-2 font-medium`}>
        {metrics.processorSuccessRates[processor].toFixed(2)}
      </Td>
    </Tr>
  );
};

export default SuccessPerProcessorTable;
